/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './pharmacy-kit.reducer';

export const PharmacyKitDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const pharmacyKitEntity = useAppSelector(state => state.pharmacyKit.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="pharmacyKitDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.pharmacyKit.detail.title">PharmacyKit</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.pharmacyKit.id">Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyKitEntity.id}</dd>
          <dt>
            <span id="offerStartDate">
              <Translate contentKey="tinyMedicRestApp.pharmacyKit.offerStartDate">Offer Start Date</Translate>
            </span>
          </dt>
          <dd>{pharmacyKitEntity.offerStartDate}</dd>
          <dt>
            <span id="offerEndDate">
              <Translate contentKey="tinyMedicRestApp.pharmacyKit.offerEndDate">Offer End Date</Translate>
            </span>
          </dt>
          <dd>{pharmacyKitEntity.offerEndDate}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.pharmacyKit.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{pharmacyKitEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.pharmacyKit.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{pharmacyKitEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.pharmacyKit.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{pharmacyKitEntity.lastupdated}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.pharmacyKit.active">Active</Translate>
            </span>
          </dt>
          <dd>{pharmacyKitEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.pharmacyKit.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{pharmacyKitEntity.cursor}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.pharmacyKit.name">Name</Translate>
            </span>
            <UncontrolledTooltip target="name">
              <Translate contentKey="tinyMedicRestApp.pharmacyKit.help.name" />
            </UncontrolledTooltip>
          </dt>
          <dd>{pharmacyKitEntity.name}</dd>
          <dt>
            <span id="taxCode">
              <Translate contentKey="tinyMedicRestApp.pharmacyKit.taxCode">Tax Code</Translate>
            </span>
          </dt>
          <dd>{pharmacyKitEntity.taxCode}</dd>
          <dt>
            <span id="mrp">
              <Translate contentKey="tinyMedicRestApp.pharmacyKit.mrp">Mrp</Translate>
            </span>
          </dt>
          <dd>{pharmacyKitEntity.mrp}</dd>
          <dt>
            <span id="offerPrice">
              <Translate contentKey="tinyMedicRestApp.pharmacyKit.offerPrice">Offer Price</Translate>
            </span>
          </dt>
          <dd>{pharmacyKitEntity.offerPrice}</dd>
          <dt>
            <span id="postPrice">
              <Translate contentKey="tinyMedicRestApp.pharmacyKit.postPrice">Post Price</Translate>
            </span>
          </dt>
          <dd>{pharmacyKitEntity.postPrice}</dd>
          <dt>
            <span id="discount">
              <Translate contentKey="tinyMedicRestApp.pharmacyKit.discount">Discount</Translate>
            </span>
          </dt>
          <dd>{pharmacyKitEntity.discount}</dd>
          <dt>
            <span id="draft">
              <Translate contentKey="tinyMedicRestApp.pharmacyKit.draft">Draft</Translate>
            </span>
          </dt>
          <dd>{pharmacyKitEntity.draft ? 'true' : 'false'}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyKit.pharmacy">Pharmacy</Translate>
          </dt>
          <dd>{pharmacyKitEntity.pharmacy ? pharmacyKitEntity.pharmacy.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/pharmacy-kit" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/pharmacy-kit/${pharmacyKitEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PharmacyKitDetail;
